export const GET_ORDERS_OPTIONS = "/orders/options"

export const ALL_ORDERS = "/orders"

export const GET_ALL_STATUS = "/status"

export const SEARCH_DYNAMIC = "/orders/dynamic/:q/:type/:product"

export const BATCH_INPUT = "/orders/search/batch"

export const CHECKBOXES = "/orders/report/checkboxes"

export const ORDER_DETAIL_BY_ID = "/orders/:q/details"

export const GET_ORDER = "/orders/:id"

export const ORDER_REPORT = "/orders/report"

export const UPDATE_ORDER_COURRIER = "/orders/updateCourier"

export const UPDATE_ORDER_STATE = "/orders/updateState"

export const GET_ORDER_BATCH_OPTIONS = "/orders/batch/options"

export const GET_ORDER_BATCH_MONITOR = "/orders/batch/monitor"

export const POST_ORDER_BATCH_FILE = "/orders/insertBatchFile"

export const GET_HISTORY = "/orders/historic"

export const GET_ONLYKEY = "/orders/onlyKey"

export const POST_REPORT_FILE = "/orders/reportFile"

export const ORDER_HISTORY = "/orders/report/history"

export const UPDATE_ORDER_STATUS_BY_AR = "/orders/updateStatusAR"

export const POST_BATIMENTO_FATURAMENTO = "/orders/evaluateFile"

export const POST_FATURAMENTO_EMBOSSING = "/orders/fileEmbossing"
